module.exports = __webpack_public_path__ + "static/media/Strain.511e7e54.svg";